module.exports = __webpack_public_path__ + "media/images/sp/specials/common/benefits_campaign-d590f149000e85a3f059d4b4f908b4f0.png";